import { render, staticRenderFns } from "./DoubleValueCell.vue?vue&type=template&id=65bbd612&"
import script from "./DoubleValueCell.vue?vue&type=script&lang=js&"
export * from "./DoubleValueCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports